import { computed, inject, nextTick, onMounted, ref } from "vue";
import Util from "@/option/common/util";
import { useEventBus, useEventListener } from "@vueuse/core";
import { DRAG_POSITION, DRAG_TYPE } from "@/option/common/dict";

export const canDropClass = "ks-drop-wrapper";
export const canHoverClass = "sk-app-edit-container";
let first = true;
//  只第一次加载即可
if (first) {
	useEventListener(document, "dragover", (e) => {
		if (hasBorderClass(e.target)) {
			e.target.classList.add("hover");
		}
	});
	useEventListener(document, "dragleave", (e) => {
		if (hasBorderClass(e.target)) {
			e.target.classList.remove("hover");
		}
	});
	useEventListener(document, "drop", (e) => {
		if (hasBorderClass(e.target)) {
			e.target.classList.remove("hover");
		}
	});

	first = false;
}

function hasBorderClass(target) {
	return target?.classList?.contains(canDropClass) || target?.classList?.contains(canHoverClass);
}

let selectRef = useEventBus("selectRef");

export function dropHandler(store, props, appInstance) {
	let drag = store.dragObject;
	if (drag.type === DRAG_TYPE.COMPONENT || drag.type === DRAG_TYPE.COMPONENT_EDIT || drag.type === DRAG_TYPE.BLOCK) {
		let cpt = { ...drag.data };
		// 已经存在ref 说明是在编辑内拖动的组件无须再次初始化数据
		if (!drag.data.ref) {
			cpt = createNode(cpt);
		} else {
			// 不可以拖动自己放到自己上面
			if (drag.targetRef === drag.data.ref) return;
			cpt = drag.data;
		}

		let originParent, originIndex;
		if (drag.data.ref) {
			// 	移动节点 先删除原位置的组件 再移入新位置
			originParent = appInstance.findParentByRef(drag.data.ref);
			// 找到就删除 找不到就算了
			if (originParent) {
				originIndex = originParent.children.findIndex((el) => el.ref === drag.data.ref);
				originParent.children.splice(originIndex, 1);
			}
		}
		//  find parent and index
		let parent = appInstance.findParentByRef(drag.targetRef);
		let index = parent?.children?.findIndex((el) => el.ref === drag.targetRef);
		switch (drag.position) {
			case DRAG_POSITION.in:
				props.schema.children.push(cpt);
				break;
			case DRAG_POSITION.left:
			case DRAG_POSITION.top:
				parent.children.splice(index, 0, cpt);
				break;
			case DRAG_POSITION.right:
			case DRAG_POSITION.bottom:
				parent.children.splice(index + 1, 0, cpt);
				break;
		}

		nextTick(() => {
			selectRef.emit(cpt);
		});
	}
}

export function createNode(cpt) {
	let newNode = {
		ref: Util.getRefId(),
		name: cpt.name,
		componentCode: cpt.code,
		classes: cpt.classes || [],
		styles: cpt.styles || {},
		prop: cpt.prop ? cpt.prop() : {},
		children: cpt.children || [],
		eventsInjection: cpt.eventsInjection,
		mountedInjection: cpt.mountedInjection,
		exposures: cpt.exposures || [],
	};
	return newNode;
}

export function useRender(emit, props, attr) {
	function handleSchemaSelect() {
		emit("select", props.schema.ref);
	}

	function handleChildSchemaSelect(ref) {
		emit("select", ref);
	}

	let isSelect = computed(() => props.schema.ref == props.select);
	let clz = computed(() => {
		// 快捷点击的类名
		let s =  props.schema?.classes?.join(" ");
		// 自定义输入的类名
		let cs = props.schema?.cusClasses?.join(" ");
		s = s + (cs || "");
		if (isSelect.value) {
			s += " active";
		}
		return s;
	});

	// 	因为编辑状态组件外面嵌套了组件 所以需要删除部分属性 加到编辑态的父级去 如position 定位配置
	function getDelStyle(styles) {
		let newStyle = {};
		for (const key in styles) {
			newStyle[key] = styles[key];
		}
		let attr = ["position", "left", "top", "bottom", "right"];
		attr.forEach((el) => {
			delete newStyle[el];
		});
		return newStyle;
	}

	// 因为编辑态外面套了壳子 而某些样式又必须作用在壳子上才有效果
	function getParentStyle() {
		let _attr = ["width", "height", "position", "left", "top", "bottom", "right", "z-index"];
		let sty = {};
		_attr.forEach((el) => {
			if (el in attr.style) {
				sty[el] = attr.style[el];
			}
		});
		return sty;
	}

	return {
		clz,
		isSelect,
		handleSchemaSelect,
		handleChildSchemaSelect,
		createNode,
		getParentStyle,
		getDelStyle,
	};
}
